import React, { useState } from "react"
import {
  MdKeyboardArrowDown,
  MdKeyboardArrowRight,
  MdKeyboardArrowUp,
} from "react-icons/md"

import * as styles from "./MobileMenu.module.scss"
import { Link } from "gatsby"
import { useLink, useSiteQuery } from "../../../../hooks/index"
import SvgIcon from "../../../Svg/SvgIcon"
import { GatsbyImage } from "gatsby-plugin-image"
import MobileImageSlider from "../../../MobileImageSlider/MobileImageSlider"

const MobileMenu = ({ menuItems, setIsOpen }) => {
  const { quoteSection, headerButton, quoteSectionTitle, headerBlogMedia } =
    useSiteQuery()
  const [openDropdown, setOpenDropdown] = useState("")
  const findId = title => {
    return title.split(" ").join("-").toLowerCase()
  }

  const [childOpenState, setChildOpenState] = useState("")

  const handleMenuClick = id => {
    const selectedMenu = menuItems.find(item => item.id === id)
    const firstChildId = selectedMenu?.children[0]?.id || ""
    setOpenDropdown(openDropdown === id ? "" : id)
    setChildOpenState(firstChildId)
  }

  const handleChildMenuClick = id => {
    setChildOpenState(childOpenState === id ? "" : id)
  }

  const handleLinkClick = () => {
    setOpenDropdown("")
    setChildOpenState("")
    setIsOpen(false)
  }

  const [menuStack, setMenuStack] = useState([
    { title: "Main Menu", items: menuItems },
  ])
  const [imageCollapsed, setImageCollapsed] = useState(true)


    const [nestedChildOpenState, setNestedChildOpenState] = useState("")

    const handleNestedChildMenuClick = id => {
    setNestedChildOpenState(nestedChildOpenState === id ? "" : id)
    }


  return (
    <>
      <nav className={`${styles.mobileMenu}`}>
        {menuStack.length === 1 && headerBlogMedia && (
          <div
            className={`${styles.advBannerWrapper} ${
              imageCollapsed ? styles.collapsed : ""
            }`}
          >
            <button
              className={styles.collapseToggle}
              onClick={() => setImageCollapsed(!imageCollapsed)}
              aria-label={imageCollapsed ? "Expand" : "Collapse"}
            >
              {imageCollapsed ? <MdKeyboardArrowDown /> : <MdKeyboardArrowUp />}
            </button>

            {!imageCollapsed && (
              <div className={styles.advBanner}>
                <div className={styles.sliderArea}>
                  <MobileImageSlider data={headerBlogMedia} />
                </div>
              </div>
            )}
          </div>
        )}
        <ul className="flex flex-col">
          {menuItems.map(menuItem => (
            <li key={findId(menuItem.title)} className={styles.parent}>
              <div
                className={`${
                  openDropdown === findId(menuItem.title)
                    ? `${styles.hasChildren} ${styles.active}`
                    : styles.hasChildren
                }`}
              >
                {menuItem.slug === "#" ? (
                  <div onClick={() => handleMenuClick(findId(menuItem.title))}>
                    {menuItem.title}
                  </div>
                ) : (
                  <Link
                    to={`${useLink(menuItem.slug)}`}
                    onClick={handleLinkClick}
                  >
                    {menuItem.title}
                  </Link>
                )}

                {menuItem.children.length > 0 && (
                  <button
                    onClick={() => handleMenuClick(findId(menuItem.title))}
                    className={styles.arrowButton}
                  >
                    {openDropdown === findId(menuItem.title) ? (
                      <MdKeyboardArrowDown />
                    ) : (
                      <MdKeyboardArrowRight />
                    )}
                  </button>
                )}
              </div>

              {openDropdown === findId(menuItem.title) && menuItem.children && (
                <ul>
                  {menuItem.children.map(child => (
                    <li key={findId(child.title)}>
                      <div
                        className={`${
                          childOpenState === findId(child.title)
                            ? `${styles.level1} ${styles.active}`
                            : styles.level1
                        }`}
                      >
                        <div className={styles.menuTitle}>
                          <div className={styles.svgWrapper}>
                            {child.svgIcon?.svgIcon && (
                              <SvgIcon
                                svgCode={child.svgIcon.svgIcon}
                                className={styles.childSvgIcon}
                              />
                            )}
                          </div>
                          <div>
                            <Link
                              to={`${useLink(child.slug)}`}
                              onClick={handleLinkClick}
                            >
                              {child.title}
                            </Link>

                            <p className={styles.subTitle}>{child.subTitle}</p>
                          </div>
                        </div>
                        {Array.isArray(child.children) &&
                          child.children.length > 0 && (
                            <button
                              onClick={() =>
                                handleChildMenuClick(findId(child.title))
                              }
                              className={styles.arrowButton}
                            >
                              {childOpenState === findId(child.title) ? (
                                <MdKeyboardArrowDown />
                              ) : (
                                <MdKeyboardArrowRight />
                              )}
                            </button>
                          )}
                      </div>
                        {childOpenState === findId(child.title) && child.children && (
                        <ul className={styles.nested}>
                            {child.children.map(nestedChild => (
                            <li key={findId(nestedChild.title)}>
                                <div
                                className={`${
                                    styles.level2
                                } ${nestedChild.children?.length > 0 ? styles.hasLevel3 : ""}`}
                                >
                                <div className={styles.menuTitle}>
                                    <div>
                                    <Link
                                        to={`${useLink(nestedChild.slug)}`}
                                        onClick={handleLinkClick}
                                    >
                                        {nestedChild.title}
                                    </Link>
                                    <p className={styles.subTitle}>{nestedChild.subTitle}</p>
                                    </div>
                                </div>
                                </div>

                                {/* directly render level3 (no toggle needed) */}
                                {nestedChild.children?.length > 0 && (
                                <div className={styles.level3Content}>
                                    <div className={styles.level3Tags}>
                                    {nestedChild.children.map((level3Child, i) => {
                                        if (!level3Child?.slug || !level3Child?.title) return null

                                        return (
                                        <a
                                            key={i}
                                            href={useLink(level3Child.slug)}
                                            onClick={handleLinkClick}
                                            className={styles.tagButton}
                                        >
                                            {level3Child.title}
                                        </a>
                                        )
                                    })}
                                    </div>
                                </div>
                                )}
                            </li>
                            ))}
                        </ul>
                        )}


                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}

          {headerButton?.map((item, index) => {
            const localizedSlug = useLink(item.slug)
            return (
              <li key={item.id || item.slug || item.title}>
                <div className={styles.level3}>
                  <Link to={localizedSlug} title={`Go to ${item.title}`}>
                    {item.title}
                  </Link>
                </div>
              </li>
            )
          })}
        </ul>
        <div className={styles.addContainer}>
          <div className={styles.quote2}>
            <p>{quoteSectionTitle}</p>
            <ul>
              {quoteSection.map((item, index) => (
                <li key={item.id || item.slug || item.title}>
                  <Link
                    to={`${useLink(item.target?.slug || item.slug).replace(
                      /^\/+/,
                      ""
                    )}`}
                    className={index === 0 ? "primaryFilled bg-white" : ""}
                    style={{ color: "#2F27C9" }}
                    title={`Go to ${item.title}`}
                    onClick={handleLinkClick}
                  >
                    {item.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </nav>
    </>
  )
}

export default MobileMenu
